// import api from '@/plugins/api';

import api from '@/plugins/api';

export default class ItemModule {
  static Check(name, parameters = {}) {
    return new ItemModule('check', name, parameters);
  }

  static Gender(name, parameters = {}) {
    return new ItemModule('gender', name, parameters);
  }

  static Date(name, parameters = {}) {
    return new ItemModule('date', name, parameters);
  }

  static DatePicker(name, parameters = {}) {
    return new ItemModule('datepicker', name, parameters);
  }

  static Dictionary(name, parameters = {}) {
    const item = new ItemModule('dictionary', name, parameters);
    item.options = parameters.options || [];
    item.dictionary = parameters.dictionary;
    item.add = !!parameters.add;
    if (parameters.setDictionary) {
      item.setDictionary = parameters.setDictionary;
    } else {
      item.setDictionary = data => data;
    }

    item.getDictionary = (model = {}) => new Promise((resolve, reject) => {
      item.options = [];
      item.loading = true;
      item.disabled = true;
      api.dictionary
        .list({
          name: item.dictionary,
          model,
        })
        .then((data) => {
          const options = item.setDictionary(data.Items.map(i => ({
            value: i.Id,
            label: i.Name,
            ...i,
          })));
          item.options = options;
          item.disabled = false;
          resolve(options);
        }, reject)
        .finally(() => {
          item.loading = false;
        });
    });
    return item;
  }

  static Mask(name, parameters = {}) {
    const item = new ItemModule('mask', name, parameters);
    item.options = parameters.options || {};
    return item;
  }

  static DocumentBirth(name, parameters = {}) {
    const item = new ItemModule('mask', name, parameters);
    item.options = {
      mask: [
        { mask: /^[IVXixv]{1,3} ?[а-яА-Я]{0,2} ?\d{0,6}$/ },
      ],
    };
    return item;
  }

  static DocumentRu(name, parameters = {}) {
    const item = new ItemModule('mask', name, parameters);
    item.options = {
      mask: '0000 000000',
    };
    return item;
  }

  static DocumentEn(name, parameters = {}) {
    const item = new ItemModule('mask', name, parameters);
    item.options = {
      mask: '00 0000000',
    };
    return item;
  }

  static Number(name, parameters = {}) {
    const item = new ItemModule('number', name, parameters);
    item.btn = parameters.btn || 'max';
    item.min = parameters.min || parameters.min === 0 ? parameters.min : -1000000000000;
    item.max = parameters.max || parameters.max === 0 ? parameters.max : 1000000000000;
    return item;
  }

  static Password(name, parameters = {}) {
    return new ItemModule('password', name, parameters);
  }

  static Phone(name, parameters = {}) {
    return new ItemModule('phone', name, parameters);
  }

  static Price(name, parameters = {}) {
    const item = new ItemModule('price', name, parameters);
    item.min = parameters.min || parameters.min === 0 ? parameters.min : -1000000000000;
    item.max = parameters.max || parameters.max === 0 ? parameters.max : 1000000000000;
    item.scale = (parameters.scale || parameters.scale === 0) ? parameters.scale : 2;
    item.currency = parameters.currency;
    return item;
  }

  static Select(name, parameters = {}) {
    const item = new ItemModule('select', name, parameters);
    item.options = parameters.options || [];
    item.add = !!parameters.add;
    return item;
  }

  static Editor(name, parameters = {}) {
    const item = new ItemModule('editor', name, parameters);
    item.config = parameters.config;
    return item;
  }

  static Text(name, parameters = {}) {
    return new ItemModule('text', name, parameters);
  }

  static TouristFio(name, parameters = {}) {
    const item = new ItemModule('touristfio', name, parameters);
    item.selectTourist = parameters.selectTourist || (() => {
    });
    return item;
  }

  constructor(type, name, {
    rules, set, get, disabled, label, loading, nameOn, postSet, submit,
  }) {
    this.$parent = null;
    this.label = label;
    this.type = type;
    this.name = name;
    this.nameOn = nameOn;
    if (get) {
      this.get = get.bind(this);
    }
    if (set) {
      this.set = set.bind(this);
    }
    if (postSet) {
      this.postSet = postSet;
    }
    this.rules = rules || [];
    this.show = false;
    this.$disabled = !!disabled;
    this.loading = !!loading;

    this.old = null;
    this.error = null;
    this.focused = false;
    this.valided = true;
    this.labelMin = false;
    this.submit = () => Promise.resolve();
    if (submit) {
      this.submit = submit;
    }
  }

  get parent() {
    return this.$parent;
  }

  set parent(value) {
    this.$parent = value;
    this.update();
  }

  get model() {
    return this.parent.model;
  }

  get observer() {
    return this.$parent.observer;
  }

  get disabled() {
    return this.$disabled || this.$parent.disabled;
  }

  set disabled(value) {
    this.$disabled = value;
  }

  get value() {
    return this.get(this.model[this.name]);
  }

  set value(value) {
    if (this.model[this.name] === value) return;
    const oldVal = this.model[this.name];
    const newVal = this.set(value);
    this.model[this.name] = newVal;
    this.observer.broadcast(this.name, newVal, oldVal);
    if (this.nameOn) {
      this.observer.broadcast(this.nameOn, this.model);
    }
    if (this.postSet) {
      this.postSet();
    }
  }

  get require() {
    return !!this.rules.find(i => i.require);
  }

  get(value) {
    return value;
  }

  set(value) {
    return value;
  }

  re() {
    this.focused = false;
    this.valided = true;
  }

  cancel() {
    this.model[this.name] = this.old;
    this.re();
  }

  update() {
    this.old = this.model[this.name];
    this.re();
  }

  async validate() {
    this.focused = true;
    if (!this.show || this.disabled) {
      this.valided = true;
      return Promise.resolve();
    }
    try {
      await this.valid();
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  }

  async valid() {
    try {
      await Promise.all([
        ...this.rules.map(i => i.validator(this.value)),
      ]);
      this.valided = true;
      this.error = null;
      return Promise.resolve();
    } catch (e) {
      this.valided = false;
      this.error = e;
      return Promise.reject(e);
    }
  }

  submit() {
    return this.parent.submit();
  }
}
